export default __webpack_public_path__ + "static/media/davi-marcos.f72ab997.mp3";